import { LossLimitDays, LossLimitKeys } from "app/utils/const";
import { useEffect } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import SetLimits from "./SetLimits/SetLimits";

type ModalContentsType = {
  selectedLossLimits: string;
  lossLimitOneDay: number | null;
  lossLimitSevenDays: number | null;
  lossLimitThirtyDays: number | null;
  setSelectedLossLimits: (payload: string) => void;
  setLossLimitOneDay: (payload: number | null) => void;
  setLossLimitSevenDays: (payload: number | null) => void;
  setLossLimitThirtyDays: (payload: number | null) => void;
  resetLimits: () => void;
  getLossLimits: () => void;
  submitLossLimit: () => void;
};

const ModalContents = ({
  selectedLossLimits,
  setLossLimitOneDay,
  setLossLimitSevenDays,
  setLossLimitThirtyDays,
  setSelectedLossLimits,
  resetLimits,
  getLossLimits,
  submitLossLimit,
}: ModalContentsType): JSX.Element => {
  const handleChange = (id: string, value: string | number) => {
    switch (id) {
      case LossLimitKeys.LOSS_LIMITS:
        setSelectedLossLimits(value as string);
        break;
      case LossLimitKeys.LIMIT_AMOUNT:
        handleSelectedLimitAmount(Number(value));
        break;
      default:
        break;
    }
  };

  const handleSelectedLimitAmount = (value: number) => {
    if (selectedLossLimits === LossLimitDays.ONE_DAY) {
      setLossLimitOneDay(value);
    } else if (selectedLossLimits === LossLimitDays.SEVEN_DAYS) {
      setLossLimitSevenDays(value);
    } else if (selectedLossLimits === LossLimitDays.THIRTY_DAYS) {
      setLossLimitThirtyDays(value);
    }
  };
  // set default value to 0 before fetching limits
  // check API for existing loss limit settings
  useEffect(() => {
    resetLimits();
    getLossLimits();
  }, []);

  return (
    <div className="loss-limits-form-modal__contents">
      <SetLimits
        handleChange={handleChange}
        submitLossLimit={submitLossLimit}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  selectedLossLimits: state.lossLimitsModel.selectedLossLimits,
});

const mapDispatchToProps = dispatch => ({
  setSelectedLossLimits: (payload: string) =>
    dispatch.lossLimitsModel.setSelectedLossLimits(payload),
  setLossLimitOneDay: (payload: number) =>
    dispatch.lossLimitsModel.setLossLimitOneDay(payload),
  setLossLimitSevenDays: (payload: number) =>
    dispatch.lossLimitsModel.setLossLimitSevenDays(payload),
  setLossLimitThirtyDays: (payload: number) =>
    dispatch.lossLimitsModel.setLossLimitThirtyDays(payload),
  resetLimits: () => dispatch.lossLimitsModel.resetLimits(),
  getLossLimits: () => dispatch.lossLimitsModel.getLossLimits(),
  submitLossLimit: () => dispatch.lossLimitsModel.submitLossLimit(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ModalContents));
